import { useState } from 'react';
import FullPageLoader from '../../../src/common/FullPageLoader';
import ConfirmPopUp from '../../../src/common/ConfirmPopUp';
import LeadHistoryModal from '../../../src/lead/common/LeadHistoryModal';
import { useLanguage } from "../../../src/context/LanguageContext";
import moment from "moment";
import * as HELPER from "../../../src/config/helper";
import { useParams } from "react-router-dom";
import {COUNTRY_CODE,APP_COUNTRY} from '../../config/constant'

const RemittanceRibbenBox = (props: any) => {
    const { id,type } = useParams<{ id: string,type:string }>()
    const formattedType = type ? type.split(/[_-]/).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ") : 'NA';
    const { insuranceDetails,remittanceDetail } = props
    const {translations} = useLanguage();
    const [loading, setLoading] = useState<boolean>(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [viewTimeLine, setViewTimeLine] = useState(false);
    const [selectedRemarkLead, setSelectedRemarkLead] = useState<any>(0);
    // eslint-disable-next-line
    const [isRemittance , setIsRemittance] = useState<boolean>(true);
    const applicationCreatedDate = insuranceDetails?.created_at ? moment(insuranceDetails.created_at).format('DD MMM, YYYY') : 'NA';
    const vehicleMmv = `${insuranceDetails?.make_name || ''} ${insuranceDetails?.model_name || ''} ${insuranceDetails?.version_name || ''}`.trim() || 'NA';
    const premiumAmount = `${HELPER.addCurrencyFormatting(Number(insuranceDetails?.insurance_premium_amount || 675).toFixed(2))}`;
    const insuranceTenure = insuranceDetails?.payment_tenure ? `${insuranceDetails?.payment_tenure} Year` : 'NA';
    const insuranceStartDate = insuranceDetails?.policy_start_date ? moment(insuranceDetails.policy_start_date).format('DD MMM, YYYY') : 'NA';
    const insuranceEndDate = insuranceDetails?.policy_start_date && insuranceDetails?.payment_tenure
        ? moment(insuranceDetails.policy_start_date).add(insuranceDetails.payment_tenure, 'years').format('DD MMM, YYYY')
        : 'NA';
 
    const handleSubmit = async () => {
        try{
            setShowConfirmation(false);
        }catch (error) {
            console.error("Error while updating EMI detail:", error);
        }finally {
            setLoading(false);
        }
    }

    /**
     * HAHNDLE HISTORY POPUP
     * @param type 
     * @param leadId 
     */
    const handleViewTimeLine = (type: boolean, leadId: any) => {
        setViewTimeLine(type);
        setSelectedRemarkLead(leadId);
    }
    
    return (
        <>
            <FullPageLoader show={loading} />
            {showConfirmation === false ? ("") : (
                <ConfirmPopUp
                    confirmNo={() => setShowConfirmation(false)}
                    confirmYes={handleSubmit}
                    message={`Are You Sure, You Want To Pay Referral Markup?`}
                    isConfirmNotVisible={true} 
                    from={"EmiComponent"}
                />
            )}
            <div className="lead-detail-top-ribben">
                <div className="top-heading top-heading-btn">
                    <h1>{translations.Remittance?.['INSURANCE_ID'] || translations.commonMsg?.loading}. INS{insuranceDetails?.id || 'NA'} { COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH && `(${formattedType})` }</h1>
                    <button className="btn-line btn-export" onClick={() => handleViewTimeLine(true, insuranceDetails?.id)}>
                    <i className="ic-Call-history m-sm-r"></i>
                    {translations.Insurance?.['View History'] || translations.commonMsg?.loading}
                    </button>
                </div>

                <div className="vechile-policy-detail">
                    {
                        COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH && 
                        <>
                            {/* Basic Details */}
                            <div className="policy-detail-txt premium-details p-lg-l remettance_basic_detail">
                                <h3>{translations.Remittance?.['BASIC_DETAILS'] || translations.commonMsg?.loading}</h3>
                                <ul>
                                    <li>
                                        <label>{translations.Remittance?.['POLICY_NUMBER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.policy_no || 'NA'}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['APPLICATION_CREATED_DATE'] || translations.commonMsg?.loading} </label>
                                        <span> {insuranceDetails?.created_at ? moment(insuranceDetails.created_at).format('DD MMM, YYYY') : 'NA'}</span>
                                    </li>
                                    <li>
                                        <label> {translations.Remittance?.['INSURER_NAME'] || translations.commonMsg?.loading}</label>
                                        <span> {insuranceDetails?.insurer_name || 'NA'}</span>
                                    </li>
                                    <li title={insuranceDetails?.customer_name}>
                                        <label> {translations.Remittance?.['CUSTOMER_NAME'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.customer_name || 'NA'}</span>
                                    
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['EFFECTIVITY_DATE'] || translations.commonMsg?.loading}</label>
                                        <span>
                                            {insuranceDetails?.policy_start_date ? moment(insuranceDetails.policy_start_date).format('DD MMM, YYYY') : 'NA'}
                                        </span>
                                    </li>
                                    <li>
                                        <label> {translations.Remittance?.['EXPIRY_DATE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.policy_end_date ? moment(insuranceDetails.policy_end_date).format('DD MMM, YYYY') : 'NA'}</span>
                                    </li>
                                    <li>
                                        <label> {translations.Remittance?.['SOURCE_TYPE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.source_type || 'NA'}</span>
                                    </li>
                                    <li>
                                        <label> {translations.Remittance?.['PLATE_NUMBER'] || translations.commonMsg?.loading} </label>
                                        <span> {insuranceDetails?.plate_no || 'NA'}</span>
                                    </li>
                                </ul>
                            </div>

                            {/* Quotation Premium Details */}
                            <div className="policy-detail-txt premium-details p-lg-l remettance_premium_detail">
                                <h3>{translations.Remittance?.['QUOTATION_PREMIUM_DETAILS'] || translations.commonMsg?.loading}</h3>
                                <ul>
                                    <li>
                                        <label>{translations.Remittance?.['FMV'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.total_fmv_car || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['OTD'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.own_theft_damage || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['BI_COVERAGE_AMOUNT'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.bi_coverage_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['BI_PREMIUM'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.bi_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['PD_COVERAGE_AMOUNT'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.pd_coverage_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['PD_PREMIUM'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.pd_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['PA_COVERAGE_AMOUNT'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.pa_coverage_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['TOTAL_PA_COVERAGE'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.total_pa_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['PA_PREMIUM'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.pa_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['BI_PD_PA'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.bi_pd_pa_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['TRA'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.tra_amount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['AON'] || translations.commonMsg?.loading}</label>
                                        <span>{`${Number(insuranceDetails?.aon_rate || 0).toFixed(2)}%`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['NET_PREMIUM'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.net_premium || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['VAT'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.vat || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['STAMP_DUTY'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.stamp_duty || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['LGT'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.local_govt_taxes || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['GROSS_PREMIUM'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.gross_premium || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['REFERRER_MARK_UP'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.referrer_mark_up || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['FINAL_PREMIUM'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.final_premium || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['CUSTOMER_DISCOUNT'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.discount || 0).toFixed(2))}`}</span>
                                    </li>
                                    <li>
                                        <label>{translations.Remittance?.['TOTAL_PREMIUM'] || translations.commonMsg?.loading}</label>
                                        <span>{`${HELPER.addCurrencyFormatting(Number(insuranceDetails?.total_premium || 0).toFixed(2))}`}</span>
                                    </li>
                                </ul>
                            </div>
                        </>
                    }
                    {
                        COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID && 
                        <>
                            {/* Basic Details */}
                            <div className="policy-detail-txt rem-basic-detail premium-details p-lg-l remettance_basic_detail rem-baisc">
                                <h3>{translations.Remittance?.['BASIC_DETAILS'] || translations.commonMsg?.loading}</h3>
                                <ul>
                                    <li title={insuranceDetails?.customer_name}>
                                        <label> {translations.Remittance?.['CUSTOMER_NAME'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.customer_name || 'NA'}</span>
                                    </li>
                                    <li title={insuranceDetails?.customer_email}>
                                        <label> {translations.Remittance?.['CUSTOMER_EMAIL'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.customer_email || 'NA'}</span>
                                    </li>
                                    <li title={`${insuranceDetails?.customer_discount_per ?? 0} %`}>
                                        <label> {translations.Remittance?.['CUSTOMER_DISCOUNT_ID'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.customer_discount_per ? insuranceDetails?.customer_discount_per : 0} %</span>
                                    </li>
                                    <li title={applicationCreatedDate}>
                                        <label>{translations.Remittance?.['APPLICATION_CREATED_DATE'] || translations.commonMsg?.loading} </label>
                                        <span> {applicationCreatedDate}</span>
                                    </li>
                                     <li title={insuranceDetails?.created_by_name}>
                                        <label>{translations.Remittance?.['CREATED_BY_REMITTANCE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.created_by_name}</span>
                                    </li>
                                    <li title={insuranceDetails?.source_type || 'NA'}>
                                        <label> {translations.Remittance?.['SOURCE_TYPE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.source_type || 'NA'}</span>
                                    </li>
                                    <li title={`INS${insuranceDetails?.id || 'NA'}`}>
                                        <label> {translations.Remittance?.['INSURANCE_ID'] || translations.commonMsg?.loading}</label>
                                        <span>INS{insuranceDetails?.id || 'NA'}</span>
                                    </li>
                                    <li title={insuranceDetails?.policy_no || 'NA'}>
                                        <label>{translations.Remittance?.['POLICY_NUMBER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.policy_no || 'NA'}</span>
                                    </li>
                                    <li title={insuranceDetails?.remittance_status_name}>
                                        <label>{translations.Remittance?.['CASE_STATUS'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.remittance_status_name}</span>
                                    </li>
                                </ul>
                            </div>
                            {/* Vehicle Details */}
                            <div className="policy-detail-txt rem-detail-txt  p-lg-l remettance_basic_detail rem-common-sec">
                                <h3>{translations.Remittance?.['VEHICLE_DETAIL'] || translations.commonMsg?.loading}</h3>
                                <ul>             
                                    <li title={vehicleMmv}>
                                        <label>{translations.Remittance?.['VEHICLE_MMV'] || translations.commonMsg?.loading}</label>
                                        <span title={vehicleMmv}> 
                                        {vehicleMmv}</span>
                                    </li>
                                     <li title={insuranceDetails?.make_year}>
                                        <label>{translations.Remittance?.['MODEL_YEAR'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.make_year}</span>
                                    </li>
                                     <li title={insuranceDetails?.vehicle_condition_name}>
                                        <label>{translations.Remittance?.['VEHICLE_CONDITION'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.vehicle_condition_name}</span>
                                    </li>
                                    <li title={insuranceDetails?.usage_type || '-'}>
                                        <label>{translations.Remittance?.['USAGE_TYPE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.usage_type || '-'}</span>
                                    </li>                                                                       
                                    <li title={insuranceDetails?.fuel_type || '-'}>
                                        <label>{translations.Remittance?.['VEHICLE_FUEL_TYPE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.fuel_type || '-'}</span>
                                    </li>       
                                   
                                    <li title={insuranceDetails?.plate_no}>
                                        <label>{translations.Remittance?.['PLATE_NUMBER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.plate_no}</span>
                                    </li>
                                </ul>
                            </div> 
                            {/* Insurance Details */}
                            <div className="policy-detail-txt rem-detail-txt p-lg-l remettance_basic_detail rem-common-sec">
                                <h3>{translations.Remittance?.['INSURANCE_DETAIL'] || translations.commonMsg?.loading}</h3>
                                <ul>                                    
                                    <li title={insuranceDetails?.insurer_name || '-'}>
                                        <label>{translations.Remittance?.['INSURER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.insurer_name || '-'}</span>
                                    </li>
                                    <li title={insuranceDetails?.lead_type_name}>
                                        <label>{translations.Remittance?.['INSURANCE_TYPE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.lead_type_name}</span>
                                    </li> 
                                     <li title={premiumAmount}>
                                        <label>{translations.Remittance?.['PREMIUM_AMOUNT'] || translations.commonMsg?.loading}</label>
                                        <span>{premiumAmount}</span>
                                    </li>
                                    <li title={insuranceTenure}>
                                        <label>{translations.Remittance?.['TENURE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceTenure}</span>
                                    </li>
                                    <li title={insuranceStartDate}>
                                        <label>{translations.Remittance?.['INSURANCE_START_DATE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceStartDate}</span>
                                    </li>                                                                                                    
                                    <li title={insuranceEndDate}>
                                        <label>{translations.Remittance?.['INSURANCE_END_DATE'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceEndDate}</span>
                                    </li>
                                    <li title={insuranceDetails?.policy_holder}>
                                        <label>{translations.Remittance?.['POLICY_HOLDER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.policy_holder}</span>
                                    </li>
                                </ul>
                            </div> 
                            {/* Agent Bank Details */}
                            <div className="policy-detail-txt rem-detail-txt p-lg-l remettance_basic_detail agent-bank-detail">
                                <h3>{translations.Remittance?.['AGENT_BANK_DETAIL'] || translations.commonMsg?.loading}</h3>
                                <ul>
                                    <li title={insuranceDetails?.agent_bank_name ?? '-'}>
                                        <label>{translations.Remittance?.['BANK_NAME'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.agent_bank_name ?? '-'}</span>
                                    </li>
                                    {/* <li></li> */}
                                    <li title={insuranceDetails?.agent_acc_no ?? '-'}>
                                        <label>{translations.Remittance?.['ACCOUNT_NUMBER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.agent_acc_no ?? '-'}</span>
                                    </li>
                                    {/* <li></li> */}
                                    <li title={insuranceDetails?.created_by_name ?? '-'}>
                                        <label>{translations.Remittance?.['ACCOUNT_HOLDER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.created_by_name ?? '-'}</span>
                                    </li>
                                </ul>
                            </div> 
                            {/* Insurer Bank Details */}
                            <div className="policy-detail-txt rem-agent-detail-txt policy-detail-txt-id p-lg-l remettance_basic_detail rem-ins-bank-sec">
                                <h3>{translations.Remittance?.['INSURER_BANK_DETAIL'] || translations.commonMsg?.loading}</h3>
                                <ul>
                                    <li title={insuranceDetails?.insurer_bank_name ?? '-'}>
                                        <label>{translations.Remittance?.['BANK_NAME'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.insurer_bank_name ?? '-'}</span>
                                    </li>
                                    <li title={insuranceDetails?.insurer_account_number ?? '-'}>
                                        <label>{translations.Remittance?.['ACCOUNT_NUMBER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.insurer_account_number ?? '-'}</span>
                                    </li>
                                    <li title={insuranceDetails?.insurer_account_holder ?? '-'}>
                                        <label>{translations.Remittance?.['ACCOUNT_HOLDER'] || translations.commonMsg?.loading}</label>
                                        <span>{insuranceDetails?.insurer_account_holder ?? '-'}</span>
                                    </li>
                                </ul>
                            </div> 
                        </>
                    }
                </div>
            </div>
            {viewTimeLine && <LeadHistoryModal viewTimeLine={viewTimeLine} selectedRemarkLead={selectedRemarkLead} isRemittance={isRemittance} handleViewTimeLine={(action: boolean, leadId: any) => handleViewTimeLine(action, leadId)} />}
        </>
    )
}

export default RemittanceRibbenBox;